import * as React from 'react';
import { Menu, Badge } from 'antd';
import {
    InboxOutlined,
    EditOutlined,
    SendOutlined,
    DeleteOutlined,
    FolderOutlined,
    FileTextOutlined,
    BoxPlotOutlined,
    MessageOutlined,
    SearchOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import './MailSidebar.scss';

interface MailSidebarProps {
    selectedFolder: string;
    onFolderChange: (folder: string) => void;
    unreadCounts: {
        inbox: number;
        drafts: number;
    };
}

const MailSidebar: React.FC<MailSidebarProps> = ({ selectedFolder, onFolderChange, unreadCounts }) => {
    const favoritesMenuItems = [
        {
            key: 'inbox',
            icon: <InboxOutlined />,
            label: (
                <span>
                    Inbox
                    {unreadCounts.inbox > 0 && (
                        <Badge count={unreadCounts.inbox} style={{ marginLeft: 8 }} />
                    )}
                </span>
            ),
        },
        {
            key: 'drafts',
            icon: <EditOutlined />,
            label: (
                <span>
                    Drafts
                    {unreadCounts.drafts > 0 && (
                        <Badge count={unreadCounts.drafts} style={{ marginLeft: 8 }} />
                    )}
                </span>
            ),
        },
    ];

    const mailboxesMenuItems = [
        {
            key: 'inbox',
            icon: <InboxOutlined />,
            label: 'Inbox',
        },
        {
            key: 'drafts',
            icon: <EditOutlined />,
            label: 'Drafts',
        },
        {
            key: 'sent',
            icon: <SendOutlined />,
            label: 'Sent',
        },
        {
            key: 'junk',
            icon: <DeleteOutlined />,
            label: 'Junk Mail',
        },
        {
            key: 'deleted',
            icon: <DeleteOutlined />,
            label: 'Deleted Items',
        },
        {
            key: 'notes',
            icon: <FileTextOutlined />,
            label: 'Notes',
        },
        {
            key: 'archive',
            icon: <BoxPlotOutlined />,
            label: 'Archive',
        },
        {
            key: 'conversations',
            icon: <MessageOutlined />,
            label: 'Conversations History',
        },
        {
            key: 'search',
            icon: <SearchOutlined />,
            label: 'Search Folders',
        },
        {
            key: 'groups',
            icon: <TeamOutlined />,
            label: 'Groups',
        },
    ];

    return (
        <div className="mail-sidebar">
            <div className="mail-sidebar-section">
                <div className="mail-sidebar-title">Favorites</div>
                <Menu
                    mode="inline"
                    selectedKeys={[selectedFolder]}
                    items={favoritesMenuItems}
                    onClick={({ key }) => onFolderChange(key)}
                    className="mail-sidebar-menu"
                />
            </div>
            <div className="mail-sidebar-section">
                <div className="mail-sidebar-title">Mailboxes</div>
                <Menu
                    mode="inline"
                    selectedKeys={[selectedFolder]}
                    items={mailboxesMenuItems}
                    onClick={({ key }) => onFolderChange(key)}
                    className="mail-sidebar-menu"
                />
            </div>
        </div>
    );
};

export default MailSidebar;
